import React, {useEffect, useState } from 'react';
import {useRsvp} from "../context/RsvpContext";
import CustomButton from "./CustomButton";
import Alert from "./Alert";
import TepeeButton from "./TepeeButton";
import RSVPApiService from "../services/rsvpApiService";

const LodgingComponent = () => {
    const {rsvp, setRsvp} = useRsvp();
    const [nocheViernes, setNocheViernes] = useState(rsvp?.noche_viernes || false);
    const [nocheSabado, setNocheSabado] = useState(rsvp?.noche_sabado || false);
    const [sabadoDisabled, setSabadoDisabled] = useState(false);
    const [selectedTepee, setSelectedTepee] = useState(rsvp?.tipo_tepee || "");
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState<string | null>(null);
    const [messageType, setMessageType] = useState<'success' | 'error' | 'info' | 'warning'>('info');
    const [numGuests, setNumGuests] = useState(rsvp?.huespedes_adultos || 0);
    const [numChildren, setNumChildren] = useState(rsvp?.huespedes_ninos || 0);
    const [bedType, setBedType] = useState(rsvp?.tipo_de_cama || "");
    const [share, setShare] = useState(rsvp?.comparte || false);

    useEffect(() => {
        if (numGuests === 1){
            setShare(true);
        }
    }, [numGuests]);


    const initialCamaOptions = [
        { name: "Individual", disabled: false },
        { name: "Matrimonial", disabled: false },
        { name: "Colchoneta", disabled: false }
    ]

    const [camaOptions, setCamaOptions] = useState(initialCamaOptions);

    const allowedGuests = rsvp?.allowedGuests || 1;

    const tepeeOptions = [
        { name: "Premium", people: "2", price: "$2,750" },
        { name: "Regular", people: "2", price: "$2,500" },
        { name: "Básica", people: "3", price: "$2,040" }
    ];

    const handleNocheViernesChange = () => {
        setNocheViernes(!nocheViernes);
        if (!nocheViernes){
            setNocheSabado(true);
            setSabadoDisabled(true);
        }
        else {
            setSabadoDisabled(false);
        }

    };

    const handleNocheSabadoChange = () => {
        setNocheSabado(!nocheSabado);
    };

    const handleAdults = (numb: number) => {
        setNumGuests(numb);
        if (numb === 1){
            setShare(true);
        }
        else {
            setShare(false);
        }
    }

    useEffect(() => {
        const newCamaOptions = [
            { name: "Individual", disabled: false },
            { name: "Matrimonial", disabled: false },
            { name: "Colchoneta", disabled: false }
        ];
        switch (selectedTepee) {
            case "Premium":
            case "Regular":
                newCamaOptions[2].disabled = true;
                if (share){
                    setBedType("Individual")
                    newCamaOptions[1].disabled = true;
                }
                break;
            case "Básica":
                newCamaOptions[0].disabled = true;
                newCamaOptions[1].disabled = true;
                setBedType("Colchoneta")
                break;
            default:
                break;
        }
        setCamaOptions(newCamaOptions);
        if (newCamaOptions.find(option => option.name === bedType && option.disabled)){
            setBedType("");
        }
    }, [bedType, selectedTepee, share]);

    const handleTepeeSelection = (tepeeName: string) => {
        setSelectedTepee(prev => prev === tepeeName ? "" : tepeeName);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!rsvp) return;

        setSaving(true);
        setMessage(null);

        if (numGuests === 0){
            setMessage('Por favor, selecciona al menos un huésped.');
            setMessageType('warning')
            setSaving(false);
            return;
        }

        if (!nocheSabado){
            setMessage('Por favor, selecciona al menos una noche.');
            setMessageType('warning')
            setSaving(false);
            return;
        }

        if (selectedTepee === ""){
            setMessage('Por favor, selecciona un tipo de tepee.');
            setMessageType('warning')
            setSaving(false);
            return;
        }

        if (bedType === ""){
            setMessage('Por favor, selecciona una preferencia de cama.');
            setMessageType('warning')
            setSaving(false);
            return;
        }

        try {
            const updated = {
                ...rsvp,
                noche_viernes: nocheViernes,
                noche_sabado: nocheSabado,
                tipo_tepee: selectedTepee,
                huespedes_adultos: numGuests,
                huespedes_ninos: numChildren,
                tipo_de_cama: bedType,
                comparte: share,
            };
            const rsvpApiService = RSVPApiService;
            const updatedRsvp = await rsvpApiService.updateRSVP(updated);
            setRsvp(updated);
            sessionStorage.setItem('rsvp', JSON.stringify(updatedRsvp));
            setMessage('¡Gracias! Tu selección de hospedaje fue guardada.');
            setMessageType('success');
        } catch (e: any) {
            setMessage('Ocurrió un error al guardar. Intenta más tarde.');
            setMessageType('error');
        } finally {
            setSaving(false);
        }
    };

    const adultCapacity = allowedGuests > 1 ? (selectedTepee !== "Básica" ? 3 : 4) : 2;

    return (
        <form className="relative mt-10" onSubmit={handleSubmit}>
            <div className="flex flex-col justify-center items-center text-white">
                <p className="text-center">Si te gustaría acompañarnos a nuestra celebración desde el
                viernes
                o quieres disfrutar de la fiesta al máximo sin preocupaciones, el venue cuenta con opción de hospedaje
                en tepees privadas tipo glamping.</p><br/>
                <p className="text-center">{'Todas las tepees son impermeables, con protección UV y cuentan con candado. Cada tepee tiene aproximadamente 3 m de altura. Incluyen tapetes, lámpara solar, cobijas nórdicas y almohadas.'}</p><br/>
                <p className="font-bold">¿Te late?</p><br/>
                <div className="bg-[#f2ece7] rounded-[40px] p-6 text-[#606060]">
                    <p className="text-center font-bold text-lg">Registro para hospedaje</p>
                    <p className="mt-4 italic">Selecciona las noches que te gustaría quedarte:</p>
                    <div className="flex flex-col justify-center items-center gap-2 mt-4">
                        <div>
                            <input
                                type="checkbox"
                                className="bg-white/20 rounded-xl shadow-xl"
                                id="viernes_check"
                                name="noches"
                                checked={nocheViernes}
                                onChange={handleNocheViernesChange}
                            />
                            <label htmlFor="viernes_check" className="ml-2">Noche de Viernes 20</label>
                        </div>
                        <div>
                            <input
                                type="checkbox"
                                className="bg-white/20 rounded-xl shadow-xl"
                                id="sabado_check"
                                name="noches"
                                checked={nocheSabado}
                                onChange={handleNocheSabadoChange}
                                disabled={sabadoDisabled}
                            />
                            <label htmlFor="sabado_check" className="ml-2">Noche de Sábado 21</label>
                        </div>
                    </div>
                    <p className="mt-4 italic">Selecciona la opción que te interesaría reservar:</p>
                    <div className="grid md:grid-cols-3 gap-4 mt-4">
                        {tepeeOptions.map(tepee => (
                            <TepeeButton
                                key={tepee.name}
                                name={tepee.name}
                                people={tepee.people}
                                price={tepee.price}
                                isSelected={selectedTepee === tepee.name}
                                onSelect={() => handleTepeeSelection(tepee.name)}/>
                        ))}
                    </div>
                    {/*Número de huéspedes con un dropdown de opciones depende de allowedGuests.*/}
                    <div className="grid grid-cols-1 gap-4 mt-8">
                        <div>
                            <label htmlFor="num-guests">Número de huéspedes <span className="font-thin">(adultos)</span> por tepee:</label>
                            <select
                                id="num-guests"
                                value={numGuests}
                                onChange={(e) => handleAdults(parseInt(e.target.value))}
                                className="flex-initial rounded-lg px-2 focus:ring-2 focus:ring-orange-500 focus:border-transparent text-[#606060] bg-white ml-2"
                            >
                                {Array.from({length: adultCapacity}, (_, i) => i).map(
                                    num => (
                                        <option key={num} value={num}>{num}</option>
                                    )
                                )}
                            </select>
                        </div>
                        {/*Número de menores de edad, también es un dropdown pero sólo se pueden seleccionar 0, 1 o 2*/}
                        <div>
                            <label htmlFor="num-minors">Menores de edad:</label>
                            <select
                                id="num-minors"
                                value={numChildren}
                                onChange={(e) => setNumChildren(parseInt(e.target.value))}
                                className="flex-initial rounded-lg px-2 focus:ring-2 focus:ring-orange-500 focus:border-transparent text-[#606060] bg-white ml-2"
                            >
                                {Array.from({length: 3}, (_, i) => i).map(
                                    num => (
                                        <option key={num} value={num}>{num}</option>
                                    )
                                )}
                            </select>
                        </div>
                    </div>
                    {/*Sección de radio buttons, pueden seleccionar entre cama individual, matrimonial o Colchoneta*/}
                    <div className="mt-4">
                        <label>Preferencia de cama:</label>
                        <div className="flex flex-row justify-center-safe gap-4 mt-2">
                            {camaOptions.map(bedTypeOptions => (
                                <label key={bedTypeOptions.name} className="flex items-center">
                                    <input
                                        type="radio"
                                        name="bedType"
                                        value={bedTypeOptions.name}
                                        checked={bedType === bedTypeOptions.name}
                                        onChange={(e) => setBedType(e.target.value)}
                                        disabled={bedTypeOptions.disabled}
                                        className="form-radio h-4 w-4 text-blue-600"/>
                                    <span className="ml-1">{bedTypeOptions.name}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    {/*Checkbox preguntando al usuario si estaría dispuestx a compartir*/}
                    <div className="mt-4">
                        {share ? (<p className="text-center text-[#8a2c47]">
                            **Considera que compartirás tepee con otrx(s) invitadx(s)
                        </p>) : null}
                    </div>
                    <div className="mt-6 w-full">
                        {message && <Alert
                            severity={messageType}
                            onClose={() => setMessage(null)}
                            className="shadow-sm mb-4"
                        >
                            {message}
                        </Alert>}
                        <div className="flex justify-center">
                            <CustomButton
                                type="submit"
                                text={saving ? 'GUARDANDO...' : 'ENVIAR'}
                                disabled={saving}
                                rounded={'rounded-full'}
                                bgColor={'bg-(--hover-color)'}
                                hoverColor={'hover:bg-(--primary-color)'}
                                className="font-bold"
                            />
                        </div>
                    </div>
                    <p className="mt-6 font-bold text-center">Eli o Lalo se pondrán en contacto contigo para coordinar el pago de la tepee.</p>
                    <p className="text-3xl mt-4">⚠️</p>
                    <p>*Reserva antes del <strong>16 de Enero</strong></p>
                    <p>*Sujeto a disponibilidad ¡APARTA PRONTO!</p>
                    <p>*<strong>NO</strong> hay reembolso en caso de cancelación</p>
                </div>
                <img src={"images/Hospedaje-img.png"} alt={"Hospedaje"} className="mt-20 mb-20"/>
            </div>
        </form>
    );
};

export default LodgingComponent;
